<template>
<div>
  <div id="fb-root"></div>
  <div id="pageContainer"></div>
</div>
</template>

<script>
export default {
  created(){
    this.fetchData();
  },
  data: function () {
    return {
    }
  },
  created: function(){
  },
  updated(){
  },
  mounted: function() {
    this.facebookProcess();
  },
  methods: {
    fetchData () {
       // fetch data
    },
    facebookProcess(){
      (function(d, s, id) {
        var js, fjs = d.getElementsByTagName(s)[0];
        if (d.getElementById(id)) return;
        js = d.createElement(s); js.id = id;
        js.src = 'https://connect.facebook.net/ko_KR/sdk.js#xfbml=1&version=v3.1';
        fjs.parentNode.insertBefore(js, fjs);
      }(document, 'script', 'facebook-jssdk'));

      this.loadFacebookPage();
      $( window ).resize(function() {
        $('#pageContent').remove()
        setTimeout(function(){
          $('#pageContainer').html(
            '<div id="pageContent" class="fb-page" data-href="https://www.facebook.com/DMCmedia" data-tabs="timeline" data-height="410" data-small-header="true" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"> <blockquote cite="https://www.facebook.com/DMCmedia" class="fb-xfbml-parse-ignore"> <a href="https://www.facebook.com/DMCmedia"></a> </blockquote></div>'
          );
          FB.XFBML.parse();
        }, 300);
      });
    },
    loadFacebookPage(){
      // pageRoot
      $('#pageContent').remove();
      $('#pageContainer').html(
        '<div id="pageContent" class="fb-page" data-href="https://www.facebook.com/DMCmedia" data-tabs="timeline" data-height="410" data-small-header="true" data-adapt-container-width="true" data-hide-cover="false" data-show-facepile="true"> <blockquote cite="https://www.facebook.com/DMCmedia" class="fb-xfbml-parse-ignore"> <a href="https://www.facebook.com/DMCmedia"></a> </blockquote></div>'
      );
      // console.log('loadFacebookPage 실행 : ' + this._uid);
    },
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/FBPage.vue